import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { AuthProvider } from "@/context/AuthContext";
import { MarketingLayout } from "@/components/layout/MarketingLayout";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";
import BrowsePage from "@/pages/BrowsePage";
import VehicleDetailPage from "@/pages/VehicleDetailPage";
import BookingFlowPage from "@/pages/BookingFlowPage";
import DriveAlfaClubPage from "@/pages/DriveAlfaClubPage";
import AlfaOnePathPage from "@/pages/AlfaOnePathPage";
import HowItWorksPage from "@/pages/HowItWorksPage";
import AboutPage from "@/pages/AboutPage";
import LoginPage from "@/pages/LoginPage";
import SignupPage from "@/pages/SignupPage";
import CustomerPortalPage from "@/pages/CustomerPortalPage";
import AdminPortalPage from "@/pages/AdminPortalPage";
import "@/App.css";

const withMarketing = (node) => <MarketingLayout>{node}</MarketingLayout>;

// Ensure every route change scrolls the window back to the top so users always
// start reading a page from its top, not wherever the previous page was scrolled.
// Also respects explicit "#hash" navigation for in-page anchors when present.
function ScrollToTop() {
  const { pathname, search, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      // Try to scroll to the anchor if it exists; fall back to top.
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: "auto", block: "start" });
        return;
      }
    }
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, search, hash]);
  return null;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={withMarketing(<HomePage />)} />
            <Route path="/vehicles" element={withMarketing(<BrowsePage />)} />
            <Route path="/vehicles/:id" element={withMarketing(<VehicleDetailPage />)} />
            <Route path="/vehicles/:id/reserve" element={withMarketing(<BookingFlowPage />)} />
            <Route path="/drive-alfa-club" element={withMarketing(<DriveAlfaClubPage />)} />
            <Route path="/alfa-one-path" element={withMarketing(<AlfaOnePathPage />)} />
            <Route path="/how-it-works" element={withMarketing(<HowItWorksPage />)} />
            <Route path="/about" element={withMarketing(<AboutPage />)} />
            <Route path="/login" element={withMarketing(<LoginPage />)} />
            <Route path="/signup" element={withMarketing(<SignupPage />)} />
            <Route path="/portal" element={<CustomerPortalPage />} />
            <Route path="/admin" element={<AdminPortalPage />} />
            <Route path="*" element={withMarketing(<HomePage />)} />
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="top-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
